import { useState, useEffect } from 'react';

export function useScrollSpy(ids, isMobile, scrollContainerRef) {
  const [activeId, setActiveId] = useState(ids[0]);

  useEffect(() => {
    // 모바일이거나 스크롤할 컨테이너가 없으면 실행하지 않음
    if (isMobile || !scrollContainerRef.current) return;

    const container = scrollContainerRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 섹션이 감지 영역에 들어오면 해당 ID를 활성화
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      {
        // 핵심: 브라우저 화면이 아니라 ref로 지정된 Box를 기준으로 감시
        root: container,
        // 상단 70px 지점부터 감지 (헤더 높이 고려), 하단 60%는 무시
        rootMargin: '-70px 0px -60% 0px',
        threshold: 0.1,
      }
    );

    // 각 섹션 엘리먼트 감시 시작
    ids.forEach((id) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    // 스크롤이 맨 위(0)일 때 첫 번째 섹션을 강제로 활성화하는 로직
    const handleScroll = () => {
      if (container.scrollTop < 10) {
        setActiveId(ids[0]);
      }
    };

    container.addEventListener('scroll', handleScroll);

    return () => {
      observer.disconnect();
      container.removeEventListener('scroll', handleScroll);
    };
  }, [ids, isMobile, scrollContainerRef]);

  console.log('ScrollY:', window.scrollY);

  return activeId;
}